import React from 'react';
import style from '../../styles/components/form.module.css';

const RedStar = () => {
    return (
        <span className={style.redStar}>*</span>
    );
}

export default RedStar;